function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Klientska-zona",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "WishMaker-Registracny-Proces_Investor-3",
  transform: "translate(-1080.000000, -448.000000)",
  stroke: "#F71D1D",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(318.000000, 226.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(24.000000, 104.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Input_Default",
  transform: "translate(0.000000, 102.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(672.000000, 13.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "x-circle-2",
  transform: "translate(67.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "x-circle"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 8,
  cy: 8,
  r: 8
}), /*#__PURE__*/React.createElement("line", {
  x1: 10.4,
  y1: 5.6,
  x2: 5.6,
  y2: 10.4,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.6,
  y1: 5.6,
  x2: 10.4,
  y2: 10.4,
  id: "Path"
}))))))))));

var SvgXCircle = function SvgXCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgXCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/x-circle.bec1b63b.svg";
export { ForwardRef as ReactComponent };